import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export enum LabReportedSignificance {
  Pathogenic = 'Pathogenic',
  LikelyPathogenic = 'Likely pathogenic',
  Benign = 'Benign',
  LikelyBenign = 'Likely benign',
  UncertainSignificance = 'Uncertain significance',
}

const checkboxOptionsMap = {
  [LabReportedSignificance.Pathogenic]: {
    id: 'omicsExplorer.filters.labReportedSignificance.pathogenic',
    searchValue: 'Pathogenic',
    intlLabel: {
      id: 'omicsExplorer.filters.labReportedSignificance.pathogenic',
      defaultMessage: 'Pathogenic',
    },
  },
  [LabReportedSignificance.LikelyPathogenic]: {
    id: 'omicsExplorer.filters.labReportedSignificance.likelyPathogenic',
    searchValue: 'Likely pathogenic',
    intlLabel: {
      id: 'omicsExplorer.filters.labReportedSignificance.likelyPathogenic',
      defaultMessage: 'Likely Pathogenic',
    },
  },
  [LabReportedSignificance.Benign]: {
    id: 'omicsExplorer.filters.labReportedSignificance.benign',
    searchValue: 'Benign',
    intlLabel: {
      id: 'omicsExplorer.filters.labReportedSignificance.benign',
      defaultMessage: 'Benign',
    },
  },
  [LabReportedSignificance.LikelyBenign]: {
    id: 'omicsExplorer.filters.labReportedSignificance.likelyBenign',
    searchValue: 'Likely benign',
    intlLabel: {
      id: 'omicsExplorer.filters.labReportedSignificance.likelyBenign',
      defaultMessage: 'Likely Benign',
    },
  },
  [LabReportedSignificance.UncertainSignificance]: {
    id: 'omicsExplorer.filters.labReportedSignificance.uncertainSignificance',
    searchValue: 'Uncertain significance',
    intlLabel: {
      id: 'omicsExplorer.filters.labReportedSignificance.uncertainSignificance',
      defaultMessage: 'Uncertain Significance',
    },
  },
};

interface BuildConfigOptions {
  searchKey?: string;
  valuesToInclude?: LabReportedSignificance[];
}

export const buildConfig = ({
  searchKey = 'interpretation',
  valuesToInclude = [
    LabReportedSignificance.Pathogenic,
    LabReportedSignificance.LikelyPathogenic,
    LabReportedSignificance.UncertainSignificance,
  ],
}: BuildConfigOptions = {}): MultiCheckboxFilterOption => ({
  id: 'omicsExplorer.filters.labReportedSignificance',
  title: {
    id: 'omicsExplorer.filters.labReportedSignificance',
    defaultMessage: 'Lab Reported Significance',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey,
    checkboxOptions: valuesToInclude.map(value => checkboxOptionsMap[value]),
  },
});
